import React from "react";
import { ReactComponent as CloseIcon } from "../assets/svg/x-close.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDirections,
  faMinus,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { addRoute, editRoute } from "../services/api";
import * as Dialog from "@radix-ui/react-dialog";
import {
  pushUserRoutesData,
  setCurrentRoute,
} from "../store/reducers/listingReducer";
import { Field, FieldInputProps, FieldMetaProps, Form, Formik } from "formik";
import * as Yup from "yup";
import { baseQueryAPI } from "../services/baseQuery";

//import {filterListing} from "../services/api";

interface IProps {
  draw: boolean;
  path: any;
  properties: any;
  directions: any;
  onRouteAdded: (souce: any, destinations: any, autoOptimize?: boolean) => void;
  onRouteRemoved: () => void;
  enableAutoOptimise: (enable: boolean) => void;
  edit: any;
}

export const SaveRoute = (props: IProps) => {
  const {
    draw,
    path,
    properties,
    directions,
    onRouteAdded,
    onRouteRemoved,
    enableAutoOptimise,
    edit,
  } = props;
  const dispatch = useDispatch();

  const [show, setShow] = React.useState<boolean>(false);
  const [routeName, setRouteName] = React.useState<any>("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [autoOptimise, setAutoOptimise] = React.useState<boolean>(false);

  const logged = useSelector((state: any) => state.listingReducer.logged);
  const currentRoute = useSelector(
    (state: any) => state.listingReducer.currentRoute
  );
  // React.useEffect(() => {
  //   if (currentRoute) {
  //     onRouteAdded(
  //       JSON.parse(currentRoute.path),
  //       currentRoute.directions ? JSON.parse(currentRoute.directions) : null,
  //       currentRoute.auto_optimise
  //     );
  //   }
  // }, [currentRoute]);

  const handleClose = () => {
    setErrorMessage("");
    setShow(false);
  };
  const handleShow = () => setShow(true);

  async function setSaveRoute() {
    setErrorMessage("");
    if (!routeName || routeName === "") {
      setErrorMessage("Route Name is required");
      return;
    }
    dispatch(setCurrentRoute(null));
    setShow(false);
    setErrorMessage("");
    setRouteName("");
  }

  function handleClearRoute() {
    dispatch(setCurrentRoute(null));
    onRouteRemoved();
  }

  function handleAutoOptimise() {
    if (autoOptimise) {
      setAutoOptimise(false);
      enableAutoOptimise(false);
    } else {
      setAutoOptimise(true);
      enableAutoOptimise(true);
    }
  }

  async function handleSave(val: any) {
    try {
      setErrorMessage("");
      let params: any = {};
      params["route_name"] = val.route_name;
      params["path"] = JSON.stringify(path);
      params["properties"] = JSON.stringify(properties);
      params["directions"] = directions ? JSON.stringify(directions) : null;
      params["auto_optimise"] = true;
      let result = await addRoute(params);
      if (!result?.data.success) {
        return;
      }
      if (result) {
        dispatch(pushUserRoutesData(result?.data.data));
        dispatch(baseQueryAPI.util.invalidateTags(["Routes"]));
      }
      setErrorMessage("");
      onRouteRemoved();
      handleClose();
    } catch (error) {
      console.error(error);
      setErrorMessage("Failed to add route, Try again");
    }
  }

  async function handleEdit(val: any) {
    try {
      setErrorMessage("");
      let params: any = {};
      params["route_name"] = val.route_name;
      params["path"] = JSON.stringify(path);
      params["properties"] = JSON.stringify(properties);
      params["directions"] = directions ? JSON.stringify(directions) : null;
      params["auto_optimise"] = true;
      params["public_id"] = edit.public_id;
      let result = await editRoute(params);
      if (!result?.data.success) {
        return;
      }
      if (result) {
        dispatch(pushUserRoutesData(result?.data.data));
        dispatch(baseQueryAPI.util.invalidateTags(["Routes"]));
      }
      setErrorMessage("");
      onRouteRemoved();
      handleClose();
    } catch (error) {
      console.error(error);
      setErrorMessage("Failed to add route, Try again");
    }
  }

  const handleSubmit = (val: any) => {
    if (edit) {
      handleEdit(val);
    } else {
      handleSave(val);
    }
  };

  return (
    <>
      {/*{!currentRoute &&
                <div className={"create-route-link"}>
                    <a onClick={handleShow} href="#"
                       className="btn btn-primary btn-small btn-rounded icon shadow add-listing">
                        <FontAwesomeIcon icon={faPlus}/><span> Save Route</span></a>
                </div>
            }*/}

      {currentRoute && draw && (
        <div className={"route-actions-link"}>
          <a
            onClick={handleClearRoute}
            href="#"
            className="btn btn-primary btn-small btn-rounded icon shadow add-listing"
          >
            <FontAwesomeIcon icon={faMinus} />
            <span> Close</span>
          </a>
        </div>
      )}
      {path.length > 1 && (
        <div className={"route-actions-link"}>
          <button
            onClick={handleAutoOptimise}
            className="btn btn-primary btn-small btn-rounded icon shadow add-listing"
          >
            <FontAwesomeIcon icon={faDirections} />
            <span>
              {autoOptimise
                ? " Disable Auto Optimize Route"
                : " Enable Auto Optimize Route"}
            </span>
          </button>
          <button
            onClick={handleShow}
            className="btn btn-primary btn-small btn-rounded icon shadow add-listing"
          >
            <FontAwesomeIcon icon={faPlus} />
            <span> Save Route</span>
          </button>
          <button
            onClick={handleClearRoute}
            className="btn btn-primary btn-small btn-rounded icon shadow add-listing"
          >
            <FontAwesomeIcon icon={faMinus} />
            <span> Close</span>
          </button>
        </div>
      )}

      <Dialog.Root open={show}>
        <Dialog.Portal>
          <Dialog.Overlay className="bg-gray-800 bg-opacity-60 fixed inset-0 z-40" />
          <Dialog.Content
            style={{ transform: "translate(-50%, -50%)" }}
            className="fixed left-1/2 top-1/2 bg-white p-6 z-40 min-w-[30rem]"
          >
            <Dialog.Title className="text-gray-900 text-lg font-semibold">
              {edit ? "Edit Route" : "Save Route"}
            </Dialog.Title>

            <Dialog.Close>
              <button onClick={handleClose} className="absolute top-6 right-6">
                <CloseIcon />
              </button>
            </Dialog.Close>

            <Formik
              initialValues={{
                route_name: edit?.route_name || "",
              }}
              onSubmit={async (val: any) => {
                handleSubmit(val);
              }}
              validationSchema={Yup.object({
                route_name: Yup.string().required("Route name is required"),
              })}
              enableReinitialize
            >
              {() => (
                <Form className="space-y-3">
                  <div className="flex flex-col gap-y-3">
                    <label className="text-sm font-medium text-gray-700">
                      Route Name
                    </label>
                    <Field name="route_name">
                      {({
                        field,
                        meta,
                      }: {
                        field: FieldInputProps<any>;
                        meta: FieldMetaProps<any>;
                      }) => (
                        <div>
                          <input
                            className="border px-4 py-2 outline-none w-full"
                            type="text"
                            {...field}
                          />
                          {meta.touched && meta.error && (
                            <div className="text-xs text-red-500 mt-2">
                              {meta.error}
                            </div>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>

                  {errorMessage ? (
                    <div className="p-3 bg-red-400 text-white mt-4">
                      {errorMessage}
                    </div>
                  ) : null}

                  <div className="mt-6 flex w-full justify-end gap-x-4">
                    <button
                      onClick={handleClose}
                      className="px-4 py-2 border"
                      type="button"
                    >
                      Close
                    </button>
                    <button
                      className="px-4 py-2 bg-primary text-white"
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
};
export default SaveRoute;
